import {ENV} from '@/constants/EnvConstants';

/**
 * Split Bills API Routes
 *
 * Centralized definition of all API endpoints related to Split Bills.
 * Use path params with `:param` and replace them at runtime.
 */

const baseUrlGroups = `${ENV.VITE_APIS_AI_BASE_DOMAIN_URL}/split`;

export const apiBaseSplitBills = {
  baseUrl: baseUrlGroups,

  endpoints: {
    // =========================
    // GROUPS
    // =========================

    /** GET /groups/{groupId} */
    getGroup: '/groups/:groupId',

    /** POST /groups */
    createGroup: '/groups',

    // =========================
    // USER DASHBOARD
    // =========================

    /**
     * GET /users/{split_user_id}/dashboard
     * Alternative: GET /users/dashboard (authenticated user)
     */
    getUserDashboard: '/users/:splitUserId/dashboard',

    /** GET /users/dashboard (logged user) */
    getMyDashboard: '/users/me/dashboard',

    // =========================
    // JOIN GROUP (OTP FLOW)
    // =========================

    /** POST /groups/:groupId/join/start */
    joinGroupStart: '/groups/:groupId/join/start',

    /** POST /groups/:groupId/join/verify */
    joinGroupVerify: '/groups/:groupId/join/verify',

    /** POST /groups/:groupId/join/resend */
    joinGroupResend: '/groups/:groupId/join/resend',

    // =========================
    // EXPENSES
    // =========================

    /**
     * GET /groups/{groupID}/expenses?offset={offset}&limit={limit}
     * Fetch group expenses with pagination (offset ("last_key": "2026-04-01T18:01:08Z") & limit (10 by default))
     */
    getGroupExpenses: '/groups/:groupId/expenses',

    /**
     * POST /groups/{groupId}/split
     * Record expense (authenticated users)
     */
    recordExpense: '/groups/:groupId/split',

    /**
     * POST /groups/{groupId}/anonymous/split
     * Record expense (anonymous users)
     */
    recordAnonymousExpense: '/groups/:groupId/anonymous/split',

    // =========================
    // SETTLEMENTS
    // =========================

    /** POST /groups/:groupId/settlements */
    confirmSettlement: '/groups/:groupId/settlements',
  },
} as const;

/**
 * Utility helper to replace path params
 *
 * Example:
 * buildPath(apiBaseSplitBills.endpoints.getGroup, { groupId: '123' })
 */
export const buildPath = (
  path: string,
  params: Record<string, string | number>,
): string => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(`:${key}`, String(value));
  }, path);
};
